import React from "react";
import "./pickup_320.css";

export default function Pickup320Details({ onQuote }) {
  const rows = [
    { model: "FORD RANGER", fund: "110,000–200,000", type1: "14,900", type3p: "14,400" },
    { model: "ISUZU D-MAX", fund: "210,000–300,000", type1: "15,800", type3p: "14,400" },
    { model: "MAZDA BT-50", fund: "310,000–400,000", type1: "16,200", type3p: "14,900" },
    { model: "MITSUBISHI TRITON", fund: "410,000–500,000", type1: "16,699", type3p: "15,300" },
    { model: "NISSAN NAVARA", fund: "510,000–600,000", type1: "17,100", type3p: "15,800" },
    { model: "TATA XENON", fund: "610,000–700,000", type1: "17,600", type3p: "16,500" },
    { model: "TOYOTA VIGO/REVO", fund: "710,000–750,000", type1: "18,000", type3p: "17,400" },
  ];

  return (
    <div className="pkg-detail pickup-320">
      <h2>Pickup คอกเสมอหัวเก๋ง (รหัส 320) — MSIG</h2>
      <p>แผนประกันภัยประเภท 1 (ซ่อมอู่ประกันภัย)</p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>รุ่นรถ</th>
            <th>ทุนประกัน</th>
            <th>เบี้ย 1 (รวมภาษี)</th>
            <th>เบี้ย 3+ (รวมภาษี)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.model}>
              <td>{r.model}</td>
              <td>{r.fund}</td>
              <td>{r.type1}</td>
              <td>{r.type3p}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>เริ่มใช้ 9 ก.ย. 2567 เป็นต้นไป (Rev.03 ปรับลดเบี้ย 10%)</p>
        <p>* รวมส่วนลด CCTV แล้ว</p>
        <button className="pkg-quote-btn" onClick={onQuote}>
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
